import React from 'react'

const ErrorText: React.FC<{ message: string }> = ({ message }) => {
    return (
        <span style={{ color: "red", fontSize: "12px" }}>{message}</span>
    )
}

export default ErrorText